import lozad from "lozad";

const imageObserver = lozad(); // lazy loads elements with default selector as '.lozad'
imageObserver.observe();

export default imageObserver;
